// extracted by mini-css-extract-plugin
export var hidden = "_sh-0";